// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rangeSlider--xIU0M {
  position: relative;
  width: 100%;
  height: 50px;
}[dir] .rangeSlider--xIU0M {
  padding: 0;
}

[dir] .trackBounds--OwOZU {
  padding: 0 18px;
}

.track--hosCX {
  position: relative;
  width: 100%;
  height: 10px;
}

[dir] .track--hosCX {
  background-color: #c3c3c3;
  border-radius: 3px;
  margin-top: 20px;
  cursor: pointer;
}

.bar--k9MH9 {
  position: absolute;
  top: 0;
  height: 10px;
  pointer-events: none;
  z-index: 1;
}

[dir] .bar--k9MH9 {
  background-color: #343c42;
  border-radius: 3px;
}

.handle--i_s5C {
  position: absolute;
  top: -5px;
  width: 8px;
  height: 20px;
  outline: none;
  transition: background-color 0.1s;
  z-index: 4;
}

[dir] .handle--i_s5C {
  background: #343c42;
  border: none;
  border-radius: 4px;
  cursor: ew-resize;
}

[dir=ltr] .handle--i_s5C {
  margin-left: -3px;
}

[dir=rtl] .handle--i_s5C {
  margin-right: -3px;
}

[dir] .handle--i_s5C:hover, [dir] .handle--i_s5C:focus {
  background: #2a2d31;
}

[dir] .handle--i_s5C.dragging--m_2ty {
  background: #2a2d31;
}

.handle--i_s5C:focus-visible {
  outline: 2px solid #343c42;
  outline-offset: 2px;
}

.gridDot--ux2XI {
  position: absolute;
  top: 1px;
  width: 8px;
  height: 8px;
  pointer-events: auto;
  z-index: 3;
}

[dir] .gridDot--ux2XI {
  border-radius: 50%;
  cursor: pointer;
}

[dir=ltr] .gridDot--ux2XI {
  margin-left: -3px;
}

[dir=rtl] .gridDot--ux2XI {
  margin-right: -3px;
}

/* Invisible expanded hit area around each dot for easier hover targeting */
.gridDot--ux2XI::before {
  content: '';
  position: absolute;
  top: -8px;
  width: 24px;
  height: 24px;
}
[dir] .gridDot--ux2XI::before {
  border-radius: 50%;
}
[dir=ltr] .gridDot--ux2XI::before {
  left: -8px;
}
[dir=rtl] .gridDot--ux2XI::before {
  right: -8px;
}

[dir] .gridDotOnTrack--MuZUj {
  background-color: #343c42;
}

[dir] .gridDotOnBar--sqE8S {
  background-color: #c3c3c3;
}

.labels--IMLIs {
  position: relative;
  width: 100%;
  height: 20px;
  display: flex;
  justify-content: space-between;
}

[dir] .labels--IMLIs {
  margin-top: 10px;
  padding: 0 18px;
}

.label--nKpgC {
  font-family: var(--base-font);
  font-size: 16px;
  font-weight: 300;
  line-height: 1.5;
  letter-spacing: 0;
  color: #111111;
  white-space: nowrap;
  pointer-events: none;
}

[dir=ltr] .labelMin--B4SYr {
  transform: translateX(-50%);
}

[dir=rtl] .labelMin--B4SYr {
  transform: translateX(50%);
}

[dir=ltr] .labelMax--d4pwM {
  transform: translateX(50%);
}

[dir=rtl] .labelMax--d4pwM {
  transform: translateX(-50%);
}

.dragTooltip--QDvCV {
  position: absolute;
  top: -8px;
  color: #fff;
  font-family: var(--base-font);
  font-size: 15px;
  font-weight: 300;
  line-height: 1;
  white-space: nowrap;
  pointer-events: none;
  z-index: 1200;
}

[dir] .dragTooltip--QDvCV {
  background: #343c42;
  border-radius: 8px;
  padding: 10px 20px;
}

[dir=ltr] .dragTooltip--QDvCV {
  transform: translateX(-50%) translateY(-100%);
}

[dir=rtl] .dragTooltip--QDvCV {
  transform: translateX(50%) translateY(-100%);
}

.dragTooltip--QDvCV::after {
  content: '';
  position: absolute;
  bottom: -6px;
  width: 0;
  height: 0;
}

[dir] .dragTooltip--QDvCV::after {
  border-top: 6px solid #343c42;
}

[dir=ltr] .dragTooltip--QDvCV::after {
  left: 50%;
  transform: translateX(-50%);
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
}

[dir=rtl] .dragTooltip--QDvCV::after {
  right: 50%;
  transform: translateX(50%);
  border-right: 6px solid transparent;
  border-left: 6px solid transparent;
}

.yearTooltip--cL85z {
  color: #fff !important;
  z-index: 1200;
  font-family: var(--base-font);
  font-size: 15px;
  font-weight: 300;
  line-height: 1;
}

[dir] .yearTooltip--cL85z {
  background: #343c42 !important;
  border-radius: 8px !important;
  padding: 10px 20px !important;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/RangeSlider/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AAEd,CALA;EAIE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AAKd;;AARA;EAIE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,YAAY;EAGZ,oBAAoB;EACpB,UAAU;AACZ;;AARA;EAIE,yBAAyB;EACzB,kBAAkB;AAGpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EAMZ,aAAa;EACb,iCAAiC;EACjC,UAAU;AACZ;;AAbA;EAKE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AAKnB;;AAbA;EASE,iBAAiB;AAInB;;AAbA;EASE,kBAAiB;AAInB;;AAEA;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EAGX,oBAAoB;EAEpB,UAAU;AACZ;;AAVA;EAKE,kBAAkB;EAGlB,eAAe;AAEjB;;AAVA;EAME,iBAAiB;AAInB;;AAVA;EAME,kBAAiB;AAInB;;AAEA,2EAA2E;AAC3E;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EAET,WAAW;EACX,YAAY;AAEd;AARA;EAOE,kBAAkB;AACpB;AARA;EAIE,UAAU;AAIZ;AARA;EAIE,WAAU;AAIZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EAEZ,aAAa;EACb,8BAA8B;AAEhC;;AARA;EAIE,gBAAgB;EAGhB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAFA;EACE,0BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAFA;EACE,2BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EAGT,WAAW;EAGX,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;AACf;;AAfA;EAIE,mBAAmB;EAEnB,kBAAkB;EAClB,kBAAkB;AAQpB;;AAfA;EAGE,6CAA6C;AAY/C;;AAfA;EAGE,4CAA6C;AAY/C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EAGZ,QAAQ;EACR,SAAS;AAIX;;AAXA;EAUE,6BAA6B;AAC/B;;AAXA;EAIE,SAAS;EACT,2BAA2B;EAG3B,kCAAkC;EAClC,mCAAmC;AAErC;;AAXA;EAIE,UAAS;EACT,0BAA2B;EAG3B,mCAAkC;EAClC,kCAAmC;AAErC;;AAEA;EAEE,sBAAsB;EAGtB,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAVA;EACE,8BAA8B;EAE9B,6BAA6B;EAC7B,6BAA6B;AAM/B","sourcesContent":[".rangeSlider {\n  position: relative;\n  width: 100%;\n  height: 50px;\n  padding: 0;\n}\n\n.trackBounds {\n  padding: 0 18px;\n}\n\n.track {\n  position: relative;\n  width: 100%;\n  height: 10px;\n  background-color: #c3c3c3;\n  border-radius: 3px;\n  margin-top: 20px;\n  cursor: pointer;\n}\n\n.bar {\n  position: absolute;\n  top: 0;\n  height: 10px;\n  background-color: #343c42;\n  border-radius: 3px;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.handle {\n  position: absolute;\n  top: -5px;\n  width: 8px;\n  height: 20px;\n  background: #343c42;\n  border: none;\n  border-radius: 4px;\n  cursor: ew-resize;\n  margin-left: -3px;\n  outline: none;\n  transition: background-color 0.1s;\n  z-index: 4;\n}\n\n.handle:hover,\n.handle:focus {\n  background: #2a2d31;\n}\n\n.handle.dragging {\n  background: #2a2d31;\n}\n\n.handle:focus-visible {\n  outline: 2px solid #343c42;\n  outline-offset: 2px;\n}\n\n.gridDot {\n  position: absolute;\n  top: 1px;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  margin-left: -3px;\n  pointer-events: auto;\n  cursor: pointer;\n  z-index: 3;\n}\n\n/* Invisible expanded hit area around each dot for easier hover targeting */\n.gridDot::before {\n  content: '';\n  position: absolute;\n  top: -8px;\n  left: -8px;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n}\n\n.gridDotOnTrack {\n  background-color: #343c42;\n}\n\n.gridDotOnBar {\n  background-color: #c3c3c3;\n}\n\n.labels {\n  position: relative;\n  width: 100%;\n  height: 20px;\n  margin-top: 10px;\n  display: flex;\n  justify-content: space-between;\n  padding: 0 18px;\n}\n\n.label {\n  font-family: var(--base-font);\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 1.5;\n  letter-spacing: 0;\n  color: #111111;\n  white-space: nowrap;\n  pointer-events: none;\n}\n\n.labelMin {\n  transform: translateX(-50%);\n}\n\n.labelMax {\n  transform: translateX(50%);\n}\n\n.dragTooltip {\n  position: absolute;\n  top: -8px;\n  transform: translateX(-50%) translateY(-100%);\n  background: #343c42;\n  color: #fff;\n  border-radius: 8px;\n  padding: 10px 20px;\n  font-family: var(--base-font);\n  font-size: 15px;\n  font-weight: 300;\n  line-height: 1;\n  white-space: nowrap;\n  pointer-events: none;\n  z-index: 1200;\n}\n\n.dragTooltip::after {\n  content: '';\n  position: absolute;\n  bottom: -6px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-top: 6px solid #343c42;\n}\n\n.yearTooltip {\n  background: #343c42 !important;\n  color: #fff !important;\n  border-radius: 8px !important;\n  padding: 10px 20px !important;\n  z-index: 1200;\n  font-family: var(--base-font);\n  font-size: 15px;\n  font-weight: 300;\n  line-height: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rangeSlider": `rangeSlider--xIU0M`,
	"trackBounds": `trackBounds--OwOZU`,
	"track": `track--hosCX`,
	"bar": `bar--k9MH9`,
	"handle": `handle--i_s5C`,
	"dragging": `dragging--m_2ty`,
	"gridDot": `gridDot--ux2XI`,
	"gridDotOnTrack": `gridDotOnTrack--MuZUj`,
	"gridDotOnBar": `gridDotOnBar--sqE8S`,
	"labels": `labels--IMLIs`,
	"label": `label--nKpgC`,
	"labelMin": `labelMin--B4SYr`,
	"labelMax": `labelMax--d4pwM`,
	"dragTooltip": `dragTooltip--QDvCV`,
	"yearTooltip": `yearTooltip--cL85z`
};
export default ___CSS_LOADER_EXPORT___;
